module.exports = __webpack_public_path__ + "img/benefits-9.0cd217a9.svg";